import * as React from 'react'
import { GenericDownloadButton } from '../GenericDownloadButton'
import IGenericButtons from '../../IGenericButtons'
import { ServiceContext } from 'src/services/provider/Service.provider'
import { IProxyDownloadDocument } from 'src/services/interfaces/IProxyDownloadDocument'
import { ShowNotification } from 'src/components/common/ShowNotification/ShowNotification'

interface IProxyDownloadButtonProps extends IGenericButtons {
  documents: IProxyDownloadDocument[]
}

export const ProxyDownloadButton: React.FC<IProxyDownloadButtonProps> = ({
  children,
  onClick,
  documents,
  disabled,
  hidenAsAChildren,
  icon,
  setLoading,
  style,
  tooltipTitle,
  tooltipTitleDisabled,
  trade
}) => {
  const { documentService } = React.useContext(ServiceContext)

  const handleDownload = () => Promise.all(documents.map(({ url, name }) => documentService.proxyDownload(url, name)))
    .catch(err => ShowNotification.Error("Erro ao fazer download", "Houve um erro ao realizar o download, favor entrar em contato."))

  return (
    <GenericDownloadButton
      onDownload={handleDownload}
      onClick={onClick}
      children={children}
      disabled={disabled}
      hidenAsAChildren={hidenAsAChildren}
      icon={icon}
      setLoading={setLoading}
      style={style}
      tooltipTitle={tooltipTitle}
      tooltipTitleDisabled={tooltipTitleDisabled}
      trade={trade}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/Refatoracao/DownloadButtons/ProxyDownloadButton/ProxyDownloadButton.tsx